type HourLabelProps = {
  label: string;
  isBold: boolean;
  testId?: string;
};

export const HourLabel = ({ label, isBold, testId = "" }: HourLabelProps) => {
  return (
    <span
      className={`m:text-base m:tracking-0.2 m:text-blue-950 m:dark:text-neutral-white ${isBold ? "m:font-bold" : "m:font-normal"}`}
      data-testid={testId}>
      {label}
    </span>
  );
};
